export default "__VITE_ASSET__BwPX6_f9__"